import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormValidators } from '@syncfusion/ej2-angular-inputs';
import {$translate} from "../../../services/internationalization/localize.service";

@Component({
    selector: 'sb-email-textfield-renderer',
    templateUrl: './email-textfield-renderer.component.html'
})
export class EmailTextfieldRendererComponent implements OnInit {
    @Input()
    savedEmail: string = "";

    @Input()
    readOnly: boolean = false;

    @Input()
    onSaveCommand: any;

    @Input()
    onErrorCommand: any;

    protected form: FormGroup;

    protected inEditMode: boolean = false;
    protected input: string = "";

    private invalidFormatError = $translate("ng.component.sb-textfield-renderer.error")`Email is invalid`;

    constructor() {
        this.form = new FormGroup({
            'email': new FormControl('', [FormValidators.email]),
        });
    }

    ngOnInit(): void {
        const emailControl = this.form.get('email');

        emailControl?.statusChanges.subscribe(status => {
            if (status === "INVALID" && emailControl.errors && emailControl.getRawValue() !== "") {
                if (emailControl.errors['email']) {
                    this.onErrorCommand && this.onErrorCommand(this.invalidFormatError);
                }
            } else {
                this.onErrorCommand && this.onErrorCommand(null);
            }
        });
    }

    processEmail(str: string): string {
        return str.toLowerCase();
    }

    onEditButtonClick(): void {
        if (!this.inEditMode) {
            this.inEditMode = true;
            this.input = this.savedEmail;
        }
    }

    onSaveButtonClick(): void {
        if (this.inEditMode) {
            this.inEditMode = false;
            this.savedEmail = this.processEmail(this.input);
            this.input = "";
            this.onSaveCommand && this.onSaveCommand(this.savedEmail);
        }
    }
}